var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColabAndComms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_255",
    "data-name": "Rectangle 255",
    width: 102.025,
    height: 97.392,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(-506 -2785)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(512 2793)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    "data-name": "Path 1076",
    d: "M15.585,67.851A15.6,15.6,0,0,0,0,83.415C-.1,96.2,15.045,103.66,25.087,95.719a.019.019,0,0,0,.02-.021c11.683-8.982,5.2-27.847-9.522-27.847m7.662,26.387c-3.581,3.281-11.583,3.4-15.2.1-.5-.8.381-2.341.8-3.061a8.29,8.29,0,0,1,2.641-2.761,1.082,1.082,0,0,1,1.26-.061,7.543,7.543,0,0,0,5.642.021,1.08,1.08,0,0,1,1.24.04A7.561,7.561,0,0,1,23.246,94.238ZM9.983,81.275c.24-7.382,10.943-7.382,11.183,0-.24,7.381-10.943,7.381-11.183,0m15.2,11.443a9.974,9.974,0,0,0-4.221-5.9c5-4.7,1.481-13.4-5.4-13.3-6.882-.08-10.382,8.622-5.4,13.3a9.974,9.974,0,0,0-4.221,5.9c-8.242-8.282-2.08-22.806,9.622-22.7,11.724-.081,17.865,14.422,9.623,22.7",
    transform: "translate(0 -1.612)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    d: "M23.438,94.736c-3.581,3.281-11.583,3.4-15.2.1-.5-.8.38-2.34.8-3.061a8.3,8.3,0,0,1,2.641-2.761,1.084,1.084,0,0,1,1.26-.06,7.536,7.536,0,0,0,5.641.02,1.085,1.085,0,0,1,1.241.04A7.564,7.564,0,0,1,23.438,94.736Z",
    transform: "translate(-0.192 -2.11)",
    fill: "#4d03e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    d: "M21.409,81.467c-.24,7.382-10.943,7.382-11.183,0,.24-7.4,10.963-7.4,11.183,0",
    transform: "translate(-0.243 -1.804)",
    fill: "#4d03e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M29.021,83.469a13.217,13.217,0,0,1-3.781,9.3,9.974,9.974,0,0,0-4.221-5.9c5-4.7,1.481-13.4-5.4-13.3-6.882-.08-10.382,8.623-5.4,13.3A9.974,9.974,0,0,0,6,92.771c-8.242-8.3-2.08-22.806,9.622-22.706a13.417,13.417,0,0,1,13.4,13.4",
    transform: "translate(-0.053 -1.665)",
    fill: "#f2ece9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    d: "M51.9,56.868A15.615,15.615,0,0,0,36.312,72.452c-.12,12.8,15.064,20.245,25.086,12.3v-.021h.021C73.1,75.752,66.619,56.868,51.9,56.868Zm7.642,26.467c-3.8,3.221-11.442,3.361-15.2.02-1.06-1.7,2.161-4.961,3.4-5.761a1.331,1.331,0,0,1,1.46-.061,7.21,7.21,0,0,0,5.4,0C56.6,76.393,59.9,81.575,59.538,83.335ZM46.3,70.312c.239-7.382,10.962-7.4,11.2,0-.24,7.381-10.963,7.381-11.2,0M61.518,81.754a9.974,9.974,0,0,0-4.221-5.9c4.982-4.7,1.481-13.383-5.4-13.3-6.882-.08-10.4,8.6-5.4,13.323a9.934,9.934,0,0,0-4.221,5.882c-8.242-8.282-2.08-22.806,9.622-22.705,11.7-.1,17.845,14.4,9.623,22.705",
    transform: "translate(-0.863 -1.352)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    d: "M57.74,70.5c-.24,7.382-10.963,7.4-11.2,0,.24-7.4,10.963-7.4,11.2,0",
    transform: "translate(-1.106 -1.544)",
    fill: "#4d03e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1082",
    "data-name": "Path 1082",
    d: "M59.729,83.833c-3.8,3.221-11.443,3.361-15.2.02-1.059-1.7,2.161-4.961,3.4-5.761a1.329,1.329,0,0,1,1.459-.061,7.2,7.2,0,0,0,5.4,0C56.787,76.891,60.088,82.073,59.729,83.833Z",
    transform: "translate(-1.053 -1.85)",
    fill: "#4d03e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1083",
    "data-name": "Path 1083",
    d: "M65.353,72.5a13.221,13.221,0,0,1-3.781,9.3,9.968,9.968,0,0,0-4.221-5.9c4.982-4.7,1.481-13.385-5.4-13.3-6.882-.081-10.4,8.6-5.4,13.324a9.929,9.929,0,0,0-4.221,5.882C34.085,73.506,40.247,59,51.949,59.1a13.417,13.417,0,0,1,13.4,13.4",
    transform: "translate(-0.916 -1.405)",
    fill: "#f2ece9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1084",
    "data-name": "Path 1084",
    d: "M88.229,67.851A15.6,15.6,0,0,0,72.645,83.436c-.1,12.8,15.044,20.225,25.086,12.3v-.02c11.683-9,5.2-27.868-9.5-27.868M95.89,94.238c-3.461,3.281-11.683,3.4-15.2.1-.5-.8.381-2.341.8-3.061a8.486,8.486,0,0,1,2.641-2.761,1.082,1.082,0,0,1,1.26-.061,7.543,7.543,0,0,0,5.642.021,1.114,1.114,0,0,1,1.26.04A7.684,7.684,0,0,1,95.89,94.238ZM82.608,81.275c.24-7.382,10.943-7.4,11.183,0-.221,7.381-10.923,7.381-11.183,0M97.831,92.718a9.946,9.946,0,0,0-4.2-5.9c4.961-4.7,1.46-13.383-5.4-13.3-6.882-.08-10.4,8.622-5.4,13.3a9.974,9.974,0,0,0-4.221,5.9c-8.242-8.282-2.08-22.806,9.623-22.7,11.683-.081,17.824,14.422,9.6,22.7",
    transform: "translate(-1.726 -1.612)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    d: "M94.053,81.467c-.24,7.382-10.943,7.382-11.183,0,.22-7.382,10.943-7.4,11.183,0",
    transform: "translate(-1.969 -1.804)",
    fill: "#4d03e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    d: "M96.082,94.736c-3.461,3.281-11.683,3.4-15.2.1-.5-.8.38-2.34.8-3.061a8.5,8.5,0,0,1,2.641-2.761,1.084,1.084,0,0,1,1.26-.06,7.536,7.536,0,0,0,5.641.02,1.117,1.117,0,0,1,1.26.04A7.685,7.685,0,0,1,96.082,94.736Z",
    transform: "translate(-1.918 -2.11)",
    fill: "#4d03e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    "data-name": "Path 1087",
    d: "M101.665,83.469a13.217,13.217,0,0,1-3.781,9.3,9.946,9.946,0,0,0-4.2-5.9c4.961-4.7,1.46-13.384-5.4-13.3-6.882-.08-10.4,8.623-5.4,13.3a9.974,9.974,0,0,0-4.221,5.9c-8.241-8.3-2.08-22.806,9.623-22.706a13.413,13.413,0,0,1,13.383,13.4",
    transform: "translate(-1.779 -1.665)",
    fill: "#f2ece9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1088",
    "data-name": "Path 1088",
    d: "M90.484,42.854,84,36.592a2.917,2.917,0,0,0-.32-3.882l-2.461-2.38a3.327,3.327,0,0,0-4.661.1c-.56-1.42-1.5-4.1-1.96-5.581a4.594,4.594,0,0,0-3.382-3.081c3.121-2.46,1.54-6.821-2.16-7.442,1.921-2.46.02-5.9-2.86-6.422,3.861-4.481-2.5-8.882-6.761-6.281A87.726,87.726,0,0,0,48.874.223c-2.1.08-4.6-.88-6.042.661-3.621-.461-7.2,3.36-4.761,6.622-2.82.38-5.522,3.48-3.741,6.182-3.02.18-5.621,3.581-3.76,6.3-3.421.2-5.941,4.18-3.321,6.9l-.8,2.141c-1.36-1.48-3.52-1.941-5.081-.46l-2.481,2.38a2.941,2.941,0,0,0-.319,3.882l-6.442,6.262a1.1,1.1,0,0,0,.04,1.6l17.4,15.424a1.057,1.057,0,0,0,1.46-.04l6.622-6.361a3.261,3.261,0,0,0,4.081-.341L44.212,49a2.906,2.906,0,0,0,.36-3.8,31.682,31.682,0,0,0,5-.4c2.4,1.62,5.762,1.94,8.7,1.96a2.877,2.877,0,0,0,.181,4l2.481,2.4a3.26,3.26,0,0,0,4.081.32l6.6,6.382a1.1,1.1,0,0,0,1.481.021L90.5,44.454A1.135,1.135,0,0,0,90.484,42.854ZM60.276,3.664c2.28-1.781,7.043.6,3.922,3.181-1.6,1.241-5.621,3.922-7.362,5.041L53.3,8.705c1.16-.82,5.761-4.161,6.981-5.041M44.732,2.224A81.713,81.713,0,0,1,56.956,3.4c-.76.54-1.5,1.08-2.261,1.621-.72.519-2.481,2.3-3.361,2.3a12.261,12.261,0,0,1-6.661-5.1Zm-4.361,1.42a3.54,3.54,0,0,1,2.28-.621,15.044,15.044,0,0,0,8.362,6.522L55.5,13.586a1.838,1.838,0,0,1,.66,1.441c-.28,2.22-3.761,2.64-5.181,1.26l-2.661-2.4-5.762-5.2a.863.863,0,0,0-.14-.1L40.131,6.524a1.766,1.766,0,0,1,.24-2.88m-3.621,6.8a3.381,3.381,0,0,1,4.261-.2v.02a.283.283,0,0,1,.08.061l8.4,7.6a1.972,1.972,0,0,1,.9,1.541,1.663,1.663,0,0,1-.76,1.28,3.431,3.431,0,0,1-3.9.48c.1.22-5.222-4.681-5.281-4.7l-.08-.08-3.8-3.44a1.547,1.547,0,0,1,.181-2.561m-3.7,6a3.6,3.6,0,0,1,4.3.2l1.5,1.34c.021.04.061.061.08.08l4.961,4.482a.019.019,0,0,0,.021.02c2.5,2.74-2.641,4.622-4.521,2.7L32.85,19.348a1.743,1.743,0,0,1,.2-2.9m-3.8,6.282a3.636,3.636,0,0,1,3.861-.14,3.242,3.242,0,0,1,.421.319h.02L36.89,25.93a.019.019,0,0,1,.021.02v.021h.02c2.461,2.761-2.681,4.6-4.541,2.681L29.008,25.61A1.757,1.757,0,0,1,29.248,22.729Zm1,33.089L14.485,41.853l5.741-5.521L35.99,50.315Zm12.443-8.4L40.211,49.8a1.105,1.105,0,0,1-1.481.02c-.1-.08-17.844-15.824-17.944-15.884-.52-.4-.881-.9-.36-1.44l2.481-2.381a1.127,1.127,0,0,1,1.481-.039l17.7,15.683C42.572,46.195,43.352,46.775,42.692,47.415Zm6.782-4.821c-1.34.42-5.6.4-7.062.5L28.289,30.39l.7-1.88a27.186,27.186,0,0,0,2.74,2.321c2.7,1.6,7.382.6,7.983-2.921,0,.28,2.38.3,2.62.261,2.24-.181,4.561-2.061,4.4-4.4,2.581.279,6.042-1.581,5.861-4.5,3.021.44,6.782-2.3,5.5-5.6,0,0,4.641-3.061,4.681-3.1,2.26-1.8,7.042.64,3.921,3.181-1.14,1-11.322,7.422-12.843,8.422a1.094,1.094,0,0,0,1.18,1.84s10.784-6.941,10.8-6.941c2.24-1.841,7.042.6,3.962,3.16l-3.342,2.421L58.076,27.87a1.083,1.083,0,0,0,1.14,1.841c.04-.04,8.422-5.222,8.443-5.262,1.46-1.06,4-.84,4.841.841.58,1.84-1.861,3.02-3.1,3.921-4.961,3.561-9.882,7.162-14.844,10.723A13.058,13.058,0,0,1,49.474,42.594Zm6.222,1.88a11.245,11.245,0,0,1-3.222-.621c1.26-.519,19.846-14.043,21.086-15.163.021.02.021.02.021.04a1.4,1.4,0,0,1,.079.18L74.8,31.991c-1.921,1.76-12.1,10.783-14.284,12.7ZM63.9,51.6a1.124,1.124,0,0,1-1.48-.021L59.936,49.2a.738.738,0,0,1,.04-1.14l1.4-1.241a1.147,1.147,0,0,0,.44-.22L73.779,35.812c.961-.86,3.481-3.1,4.442-3.922a1.153,1.153,0,0,1,1.5.04l2.46,2.381c.52.52.181,1.04-.36,1.44C81.762,35.772,63.958,51.516,63.9,51.6Zm8.483,5.981-5.741-5.522L82.4,38.072l5.742,5.522Z",
    transform: "translate(-0.28 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    d: "M56.829,15.121c-.28,2.221-3.76,2.641-5.181,1.26l-2.661-2.4-5.762-5.2a.863.863,0,0,0-.14-.1L40.8,6.619c-1.84-1.7.56-3.741,2.521-3.481A15.044,15.044,0,0,0,51.688,9.66L56.169,13.7a1.746,1.746,0,0,1,.66,1.42",
    transform: "translate(-0.954 -0.074)",
    fill: "#b9ccf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1090",
    "data-name": "Path 1090",
    d: "M37.993,27.927c-.28,2.241-3.781,2.641-5.2,1.26l-3.381-3.041c-2.361-2.459,2.12-4.48,4.1-3.02a3.4,3.4,0,0,1,.42.32h.021l3.341,3.021a.019.019,0,0,1,.02.02v.021h.021A1.81,1.81,0,0,1,37.993,27.927Z",
    transform: "translate(-0.683 -0.538)",
    fill: "#b9ccf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    "data-name": "Path 1091",
    d: "M45.047,24.375c-.28,2.221-3.781,2.62-5.181,1.26l-6.542-5.922c-2.521-2.721,2.641-4.641,4.521-2.681,1.06.941,5.4,4.881,6.542,5.9a.019.019,0,0,0,.02.02A1.724,1.724,0,0,1,45.047,24.375Z",
    transform: "translate(-0.776 -0.386)",
    fill: "#b9ccf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    "data-name": "Path 1092",
    d: "M51,19.7a1.666,1.666,0,0,1-.761,1.28,3.427,3.427,0,0,1-3.9.48c-.14,0-5.14-4.6-5.381-4.781l-3.8-3.441a1.578,1.578,0,0,1-.6-1.26c0-.66.641-1.24,1.22-1.6a3.341,3.341,0,0,1,3.821.1V10.5c.12.08,8.382,7.581,8.5,7.662A1.945,1.945,0,0,1,51,19.7Z",
    transform: "translate(-0.869 -0.234)",
    fill: "#b9ccf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    d: "M57.755,3.437c-.76.54-1.5,1.081-2.261,1.621-.719.52-2.481,2.3-3.36,2.3a12.267,12.267,0,0,1-6.662-5.1A87.608,87.608,0,0,1,57.755,3.437Z",
    transform: "translate(-1.08 -0.054)",
    fill: "#b9ccf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    d: "M66.207,5.3a2.24,2.24,0,0,1-1,1.6l-2.7,1.961-4.662,3.1L54.3,8.779c1.14-.8,5.762-4.162,6.982-5.041,1.54-1.161,4.941-.68,4.921,1.56",
    transform: "translate(-1.29 -0.075)",
    fill: "#b9ccf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M75.789,32.669c-1.92,1.76-12.1,10.783-14.283,12.7-2.1-.16-6.122,0-8.063-.84,1.26-.52,19.846-14.044,21.086-15.164.021.02.021.02.021.04a1.735,1.735,0,0,1,.079.18Z",
    transform: "translate(-1.27 -0.698)",
    fill: "#b9ccf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    d: "M69.759,29.412c-5.482,3.941-10.943,7.922-16.424,11.883-2.62,2.16-7.3,1.861-10.523,2.04l-14.123-12.7.7-1.88a27.2,27.2,0,0,0,2.741,2.321c2.7,1.6,7.381.6,7.982-2.921,0,.28,2.38.3,2.62.26,2.24-.18,4.561-2.06,4.4-4.4,2.58.28,6.041-1.581,5.861-4.5,3.02.44,6.781-2.3,5.5-5.6,0,0,4.641-3.061,4.681-3.1,2.261-1.8,7.042.64,3.922,3.182-1.14,1-11.323,7.421-12.843,8.422a1.094,1.094,0,0,0,1.18,1.84s10.783-6.942,10.8-6.942c2.241-1.84,7.043.6,3.962,3.161l-3.341,2.421-8.382,5.221a1.083,1.083,0,0,0,1.14,1.84c.04-.04,8.422-5.221,8.442-5.261,1.46-1.06,4.021-.841,4.841.841.541,1.8-1.9,2.98-3.141,3.881",
    transform: "translate(-0.682 -0.242)",
    fill: "#b9ccf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    d: "M83.607,35.621c.04.34-.44.72-.72.94l-17.824,15.8a1.124,1.124,0,0,1-1.48-.021L61.1,49.965a.738.738,0,0,1,.04-1.14l1.4-1.241a1.147,1.147,0,0,0,.44-.22L74.945,36.582l2.94-2.621c.421-.28,1.621-1.68,2.221-1.581a1.075,1.075,0,0,1,.76.3l2.46,2.38a.7.7,0,0,1,.28.56",
    transform: "translate(-1.446 -0.77)",
    fill: "#8870f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    "data-name": "Path 1098",
    d: "M43.135,47.58a.758.758,0,0,1-.24.56l-2.481,2.38a1.1,1.1,0,0,1-1.48.021l-17.825-15.8c-.18-.14-.28-.24-.44-.38a.752.752,0,0,1-.039-1.14l2.481-2.381a1.126,1.126,0,0,1,1.48-.04l17.7,15.684C42.535,46.78,43.175,47.18,43.135,47.58Z",
    transform: "translate(-0.484 -0.726)",
    fill: "#8870f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    "data-name": "Path 1099",
    d: "M36.035,51.179,30.313,56.7,14.529,42.717,20.27,37.2Z",
    transform: "translate(-0.345 -0.884)",
    fill: "#8870f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    "data-name": "Path 1100",
    d: "M89.478,44.541,73.714,58.5l-5.741-5.521L83.756,39Z",
    transform: "translate(-1.615 -0.927)",
    fill: "#8870f3"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_261",
    "data-name": "Rectangle 261",
    width: 114,
    height: 114,
    transform: "translate(506 2785)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColabAndComms);
export default __webpack_public_path__ + "static/media/colabAndComms.fd6de28debbd032dc76240ae7d330067.svg";
export { ForwardRef as ReactComponent };